export default __webpack_public_path__ + "static/media/project3.b10944eb.png";